import React, { Fragment } from 'react'
import moment from 'moment'
import injectStyles from 'react-jss'

import Grid from '@material-ui/core/Grid'
import useGraphQLFetch from '../../../../Utils/Hooks/useGraphQLFetch'
import ScanUniqueGraph from './Charts/ScanUniqueGraph'
import ScanColumnsGraph from './Charts/ScanColumnsGraph'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import exportIcon from 'Assets/Images/icons/export.svg'

import { formatScansCity, formatScansOs, getFormattedValue } from './utils'
import { downloadStringAsFile } from '../../../../Utils/Misc'
import { escapeCsvString } from '../../../../shared/csv'
import {
  chartOptionsByCityGraph,
  chartOptionsScanByOsGraph,
  headers,
} from './options'
import { getScansData } from './gql'
import { styles } from './styles'

const dateNow = moment().set({
  'hour': 23,
  'minute': 59,
  'second': 59,
  'millisecond': 59,
})

const CampaignPerforming = ({ campaignId, campaignName, classes }) => {
  const { data: scansData, isLoaded } = useGraphQLFetch({
    fetchFn: getScansData,
    defaultFetchArgs: campaignId,
    mapResponse: data => data.campaign.scanUsersData.nodes,
  })
  const onExportData = () => {
    if (scansData.length) {
      const valuesHeaders = Object.values(headers)
      const keysHeaders = Object.keys(headers)
      const campaignNameFormatted = campaignName.replace(/ /g, '_')
      const fileName = `export_scans_${campaignNameFormatted}.csv`
      let content = valuesHeaders.join(',')
      scansData.forEach(row => {
        const newRow = keysHeaders.map(headerName => {
          const value = getFormattedValue({ headerName, row, campaignName })
          return typeof value === 'string' ? escapeCsvString(value) : value
        })
        content += '\n' + newRow.join(',')
      })
      downloadStringAsFile(content, fileName, 'text/csv')
    }
  }

  return (
    <Fragment>
      <h1 className={classes.titleBlock}>
        <div>How’s the campaign performing?</div>
        <div>
          {isLoaded ? (
            <img src={exportIcon} alt="icon" onClick={onExportData} />
          ) : null}
        </div>
      </h1>
      {isLoaded ? (
        <Fragment>
          <Grid container>
            <Grid xs={12} sm={12}>
              <ScanUniqueGraph dateNow={dateNow} scansData={scansData} />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <ScanColumnsGraph
                dateNow={dateNow}
                scansData={scansData}
                formatData={formatScansOs}
                chartOptions={chartOptionsScanByOsGraph}
                scansTitle="Operating system"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <ScanColumnsGraph
                dateNow={dateNow}
                scansData={scansData}
                formatData={formatScansCity}
                chartOptions={chartOptionsByCityGraph}
                scansTitle="Cities"
              />
            </Grid>
          </Grid>
        </Fragment>
      ) : (
        <LoadingIndicator />
      )}
    </Fragment>
  )
}

export default injectStyles(styles)(CampaignPerforming)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/index.js